import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { compact } from 'lodash-es';
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { ConfirmationModal, MenuItem, Select, Typography } from 'seagull';
import { routes } from '~/constants';
import { useOverlayContext, useIoContext } from '~/contexts';
import { handlePromise } from '~/infra/utils';
import { relationshipSummaryModel } from '~/models';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import { getClientViewURL } from '../unAuthorizedPages/LoginScreen';
function getAgreementLinks(relationship) {
    return compact([
        {
            id: 'home',
            text: 'Visit client portal',
            link: routes.home
        },
        {
            id: 'agreement',
            text: 'View agreement',
            link: routes.agreement(relationship.id)
        },
        !relationshipSummaryModel.isTerminated(relationship) && {
            id: 'pm',
            text: 'Manage payment methods',
            link: routes.paymentMethods(relationship.id)
        },
        {
            id: 'team',
            text: 'Add team member',
            link: routes.team
        },
        {
            id: 'business',
            text: 'Change company name',
            link: routes.businessDetails
        },
        {
            id: 'profile',
            text: 'Change contact details',
            link: routes.profile
        },
        {
            id: 'invoices',
            text: 'View invoices',
            link: routes.invoices(relationship.id)
        },
        {
            id: 'activity',
            text: 'View activity log',
            link: routes.activityLog(relationship.id)
        }
    ]);
}
export default function ShareAgreementLinksModal(param) {
    let { relationship, dismissModal } = param;
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            pathname: ''
        }
    });
    const { copyToClipboard } = useIoContext();
    const { showErrorToast, showSuccessToast } = useOverlayContext();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        textAlignCenter: false,
        title: "Share direct link",
        testId: "direct-links-modal",
        content: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    testId: "direct-links-title",
                    children: [
                        "Invite",
                        ' ',
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            weight: "bold",
                            children: relationshipSummaryModel.customerBusinessName(relationship)
                        }),
                        ' ',
                        "to:"
                    ]
                }),
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "pathname",
                    rules: requiredValidation(),
                    render: (p)=>/*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                            collapseHelperText: false,
                            label: "Choose action",
                            testId: "select-direct-link"
                        }, connectControllerToTextField(p)), {
                            children: getAgreementLinks(relationship).map((param)=>{
                                let { id, text, link } = param;
                                return /*#__PURE__*/ _jsx(MenuItem, {
                                    value: getClientViewURL(link),
                                    testId: "direct-link-".concat(id),
                                    children: text
                                }, link);
                            })
                        }))
                })
            ]
        }),
        primaryButtonLabel: "Copy link",
        secondaryButtonLabel: "Cancel",
        onSecondaryButtonClick: dismissModal,
        onPrimaryButtonClick: handleSubmit(async (param)=>{
            let { pathname } = param;
            const result = await handlePromise(copyToClipboard(window.location.origin + pathname));
            if (!result.success) {
                showErrorToast('Failed to copy link', 'copy-link-error');
            } else {
                showSuccessToast('Link was copied to clipboard', 'copy-link-success');
                dismissModal();
            }
        })
    });
}
